export default __webpack_public_path__ + "static/media/doneffectueActual.9dca9128.png";